<template>
  <v-card height="100%" class="pa-4" rounded="lg">
    <h2 class="mb-2" style="font-size: 20px;">Abandoned checkouts recovery</h2>
    <div class="d-flex align-start mb-4" style="gap: 12px">
      <h2 style="font-size: 24px;">{{ abcheckoutConversionRate }}%</h2>
      <v-divider vertical></v-divider>
      <div>
        <p class="mb-0 font-weight-bold">{{ abcheckoutCompletedOrder }}</p>
        <p class="mb-0 description--text" style="font-size: 12px;">Orders</p>
      </div>
      <v-divider vertical></v-divider>
      <div>
        <p class="mb-0 font-weight-bold">{{ currency.priceFormat(abCheckoutRevenue) }}</p>
        <p class="mb-0 description--text" style="font-size: 12px;">Profit</p>
      </div>
    </div>
    <a class="info--text" href="https://bambooz.com/help/article/61b9aaf52a32f7000af7d605/"
      >How to recover abandoned checkouts to improve conversion rate?</a
    >
    <h3 class="mt-9 font-weight-medium">EMAIL/SMS/OTHER CONVERSION FUNNEL</h3>
    <Bar v-if="!isLoading" :chartdata="abcheckoutConversion" :options="abcheckoutChartOptions" :height="300" />
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Bar from '@/components/chart/Bar';
import { FETCH_ABCHECKOUT_CONVERSION } from '@/store/actions.type';
import currency from '@/helpers/currency';

export default {
  props: {
    dateRange: {
      from: Date,
      to: Date,
      timezone: String,
    },
    stores: Array,
    timezone: String,
  },
  components: {
    Bar,
  },
  data() {
    return {
      isLoading: false,
      data: null,
      filters: {
        capturedDate: {
          startDate: '',
          endDate: '',
          timezone: '',
        },
        stores: '',
        timezone: 'America/Los_Angeles',
        referenceMethod: 'email',
      },
      currency,
    };
  },
  async created() {
    await this.createFilterObj();
    await this.fecthData();
  },
  methods: {
    createFilterObj() {
      const { stores, capturedDate, referenceMethod } = this.$route.query;
      this.filters.capturedDate = capturedDate
        ? capturedDate
        : {
            startDate: this.$props.dateRange.from
              ? moment(this.$props.dateRange.from).format('YYYY-MM-DD')
              : moment()
                  .tz(this.timezone)
                  .format('YYYY-MM-DD'),
            endDate: this.$props.dateRange.to
              ? moment(this.$props.dateRange.to).format('YYYY-MM-DD')
              : moment()
                  .tz(this.timezone)
                  .format('YYYY-MM-DD'),
            timezone: this.$props.timezone ? this.$props.timezone : 'America/Los_Angeles',
          };
      this.filters.referenceMethod = referenceMethod ? referenceMethod : 'email';
      this.filters.stores = stores
        ? stores
        : this.$props.stores && this.$props.stores.length
        ? this.$props.stores.join(',')
        : localStorage.getItem('store-id');
      return this.filters;
    },
    async fecthData() {
      this.isLoading = true;
      await this.$store.dispatch(FETCH_ABCHECKOUT_CONVERSION, this.filters);
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters(['abcheckoutConversion', 'abcheckoutChartOptions']),
    abcheckoutCompletedOrder() {
      return this.$store.getters['abcheckoutCompletedOrder'];
    },
    abCheckoutRevenue() {
      return this.$store.getters['abCheckoutRevenue'];
    },
    abcheckoutConversionRate() {
      return this.$store.getters['abcheckoutConversionRate'];
    },
  },
  watch: {
    '$route.query': function() {
      this.createFilterObj();
      this.fecthData();
    },
  },
};
</script>
